import { cleanDocument, isCnpj, isCpf, onlyNumbers } from './formataValidaDocumentos'

export type FilterValuesType = {
  [key: string]: string | number | Date | undefined | null
}

const changeFilterToString = (values: FilterValuesType | undefined): string => {
  if (!values || typeof values !== 'object') return ''

  const filters: string[] = []

  for (const key in values) {
    if (Object.prototype.hasOwnProperty.call(values, key)) {
      const value = values[key]

      if (
        value !== null &&
        value !== undefined &&
        !(key === 'st_status' && value === 'T') &&
        !(key === 'st_flex' && value === 'T')
      ) {
        if (value instanceof Date) {
          if (key.includes('inicial')) {
            filters.push(`${key}=${value.toISOString().split('T')[0]}T00:00:00.000Z`)
          } else if (key.includes('final')) {
            filters.push(`${key}=${value.toISOString().split('T')[0]}T23:59:59.999Z`)
          } else {
            filters.push(`${key}=${value.toISOString()}`)
          }
        } else if (typeof value === 'string' && isCpf(value)) {
          filters.push(`${key}=${onlyNumbers(value)}`)
        } else if (typeof value === 'string' && isCnpj(value)) {
          filters.push(`${key}=${cleanDocument(value)}`)
        } else if (value !== '') {
          filters.push(`${key}=${value}`)
        }
      }
    }
  }

  return filters.join('&')
}

export default changeFilterToString
